<template>

  <!-- <div id="app" class="surface-100"> -->
  <div id="app" >
    <Toast />
    <RouterView />
    <DynamicDialog/>
    <Navbar v-if=" $route.meta.hideNavBar ? !$route.meta.hideNavBar : true"/>
    <SideBar v-if=" $route.meta.hideSideBar ? !$route.meta.hideSideBar : true"/>
    <FooterBar v-if=" $route.meta.hideFooter ? !$route.meta.hideFooter : true"/>
  </div>
</template>

<script>
import Toast from 'primevue/toast'
import Navbar from './components/header/headerNavbar.vue'
import { RouterView } from 'vue-router'
import DynamicDialog from 'primevue/dynamicdialog';
import SideBar from '../src/components/sidebar/sideBarTwo.vue'
import { useNotificationStore } from './stores/notificationStore'
import FooterBar from './components/footer/footerBar.vue'

export default {
  name: 'App',
  
  components: { 
      Toast, 
      RouterView,
      DynamicDialog,
      Navbar,
      SideBar,
      FooterBar,
    },
    mounted(){
      this.notificationCount = 0;
      const notificationStore = useNotificationStore();   
   
          window.Echo.channel('App.Models.User.'+localStorage.getItem('user-token')).listen('SendCmcDueNotification', (e) => {           
                notificationStore.$patch((state)=>{
                  state.notifications.push(e)
                })          
          });
    },
}
</script>

<style>

html {
  font-size: 13px;
}

html, body {
    height: calc(100% - 55px);
    margin: 0;
    padding: 0;
    background-color: #FAFAFA; /* fallback */
}


.progress-spinner {
    position: fixed;
    z-index: 999;
    /* height: 0.3rem; */
    height: 40px;
    width: 40px;
    /* width: 0.3rem; */
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */
.progress-spinner:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  background-color: rgba(0,0,0,0.53);
}


.main-content {
    /* height: calc(100vh - 40px);
    padding-top: 55px;
    padding-left: 220px;
    padding-right: 5px;
    padding-bottom: 10px;
    background-color: #FAFAFA;  */

    height: calc(100vh - 50px);            /* covers full height */
    width: calc(100vw - 1rem);                   /* full width */
    box-sizing: border-box;         /* include padding in width calc */
    padding-top: 55px;
    padding-left: 220px;            /* keep sidebar spacing */
    padding-right: 5px;
    /* padding-bottom: 3px; */
    background-color: #FAFAFA;
    overflow-x: hidden; 
    /* overflow-y: hidden; */
}

.main-card {
    height: calc(100vh - 165px); /* 55px topbar + 20px padding/margin */
    box-sizing: border-box;
    background: #fff;
    border-radius: 12px;
    padding: 1rem;
    overflow: hidden; /* prevent content overflow */
}

</style>
